<template >
  <boxDropDown title="Gerar arquivo ACJEF">
    <template class="support-tools">

      <div class="form-group col-md-6">
        <label for="companyIdToAddAccountant">ID da empresa</label>
        <input type="text" class="form-control" v-model="dataSend.companyId" placeholder="ID da empresa" id="companyIdToAddAccountant">
      </div>

      <div class="form-group col-md-6">
        <label for="employeeIdToDualRole">ID da unidade de negócio</label>
        <input type="text" class="form-control" v-model="dataSend.businessUnit" placeholder="ID da unidade de negócio" id="employeeIdToDualRole">
      </div>

      <div class="form-group col-md-6">
        <div class="input-group input-with-date">
          <label>Data Inicial</label>
          <datepicker  ref="duplicateDaysInitDate" v-model="dataSend.initDate" :language="ptBR"
            :format="customFormatter" placeholder="DD/MM/AAAA" />
          <i aria-hidden="true" style="pointer-events: none; top: 35px;">
            <ion-icon name="calendar"></ion-icon>
          </i>
        </div>
      </div>

      <div class="form-group col-md-6">
        <div class="input-group input-with-date">
          <label>Data Final</label>
          <datepicker ref="duplicateDaysEndDate" v-model="dataSend.endDate" :language="ptBR"
            :format="customFormatter" placeholder="DD/MM/AAAA" />
          <i aria-hidden="true" style="pointer-events: none; top: 35px;">
            <ion-icon name="calendar"></ion-icon>
          </i>
        </div>
      </div>

      <InputCheckbox col="12" label="Incluir demitidos" @valueCheckbox="value => dataSend.haveFired = value"/>

      <div class="send-data-tools form-group col-md-12">
        <button class="btn btn-primary" @click="sendData()">
          <span v-if="true">Gerar</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
        <span class="send-data-tools__validate">{{ messageValidateFields }}</span>
      </div>
    </template>
  </boxDropDown>
</template>

<script>
  import { ptBR } from "vuejs-datepicker/dist/locale";
  import datepicker from "vuejs-datepicker";
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";
  import InputCheckbox from "../../../components/inputs/inputCheckbox.vue";

  export default {
    name: "generate-file-acjef",
    components: {
      boxDropDown,
      datepicker,
      InputCheckbox,
    },
    data() {
      return {
        ptBR,
        messageValidateFields: "",
        dataSend: {
          companyId: "",
          businessUnit: "",
          initDate: "",
          endDate: "",
          haveFired: false,
        },
        contentSetting: ""
      }
    },
    methods: {
      customFormatter(date) {
        const dateWithoutTime = moment(date).startOf('day').toDate();
        return moment(dateWithoutTime).format('DD/MM/YYYY');
      },
      validateFields() {
        if (!this.dataSend.companyId) {
          this.messageValidateFields = "Preencha o campo de ID da empresa";
          return false;
        } else {
          console.log(this.dataSend.companyId.length);
          if (this.dataSend.companyId.length !== 32) {
            this.messageValidateFields = "ID da empresa inválido";
            return false;
          }
        }

        if (!this.dataSend.businessUnit) {
          this.messageValidateFields = "Preencha o campo de Unidade de negócio";
          return false;
        }

        if (!this.dataSend.initDate) {
          this.messageValidateFields = "Preencha o campo de data inicial";
          return false;
        }

        if (!this.dataSend.endDate) {
          this.messageValidateFields = "Preencha o campo de data final";
          return false;
        } else {
          if (moment(this.dataSend.endDate).isBefore(this.dataSend.initDate)) {
            this.messageValidateFields = "Data final não pode ser anterior a data inicial";
            return false;
          }
        }

        this.messageValidateFields = "";
        return true;
      },
      sendData() {
        if (!this.validateFields()) {
          return;
        }

        console.log(this.dataSend);
      }
    }
  }
</script>

<style lang="scss" scoped>
  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .support-tools {
    &__warning {
      padding: 10px;
      text-align: center;
      background-color: #FFDF8D;
      border-radius: 8px !important;
      color: #FF445D;
    }
  }

  .send-data-tools {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px;

    &__validate {
      color: #ed6b75;
    }
  }

  .btn-primary {
    margin: 0 !important;
  }

  .full-width{
    width: 100% !important;
  }

  .spacing-bottom{
    margin-bottom: 8px;
  }

  .company-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F0F0F0;
    padding: 10px 10px 10px 20px;
    margin-bottom: 15px;

    &__title {
      font-weight: bold;
      color: #201E1E;
    }

    &__close {
      height: 16px;
      width: 16px;
      font-size: 16px;
      color: #E74A4E;
      cursor: pointer;
    }
  }

  .center{
    margin: auto;
  }

  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/generateFileACJEF.vue